import { type RouteLocationRaw, useRouter } from 'vue-router'

export const useBackToPreviousPage = (defaultPath: RouteLocationRaw) => {
  const router = useRouter()

  return () => router.push(defaultPath)
}
